import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FocusLayout from 'layouts/FocusLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

const VERIFY_FUND_INVITE_LINK_MUTATION = gql(`
  mutation VerifyFundInviteLink($id: ID!) {
    verifyFundInviteLink(id: $id) {
      id
    }
  }
`);

const FundInviteLinkPage: FC = () => {
  const navigate = useNavigate();
  const { fundInviteLinkId } = useParams<{ fundInviteLinkId: string }>() as {
    fundInviteLinkId: string;
  };

  const [verifyFundInviteLink, { loading, error, data }] = useMutation(
    VERIFY_FUND_INVITE_LINK_MUTATION,
    {
      variables: {
        id: fundInviteLinkId,
      },
    }
  );

  useEffect(() => {
    verifyFundInviteLink().then(data => {
      if (!data.data?.verifyFundInviteLink?.id) return;
      navigate(`/invest/fund-invites/${data.data?.verifyFundInviteLink.id}/confirm`);
    });
  }, [navigate, verifyFundInviteLink]);

  const renderContent = () => {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} />;

    return <div>{data && <p>Redirecting ...</p>}</div>;
  };

  return <FocusLayout>{renderContent()}</FocusLayout>;
};

export default FundInviteLinkPage;
